import React from 'react';

import Layout from '../components/Layout';
import Scroll from '../components/Scroll';

import config from '../../config';
import Footer from '../components/Footer';
import Header from '../components/Header';
import ScrollToTop from '../components/ScrollToTop';


import p13 from '../assets/images/nature.jpg';
import p14 from '../assets/images/nature.gif';

const IndexPage = () => (
  <Layout>
    <Header />

    <div className="col-lg-6">
            <a className="portfolio-item" href="#">
              <span className="caption">
                <span className="caption-content">
                  <h2></h2>
                  <p className="mb-0">
                   <b>In the Beginning, Nature was Created...<i className="fa fa-leaf fa-spin"></i></b>
                  </p>
                </span>
              </span>
              <img className="img-fluid" src={p13} alt="" />
            </a>


          </div>

  

    


    

    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="http://touristhub.netlify.app/" className="btn btn-xl btn-light mr-4">
        Tourism
        </a>
        
      </div>
    </section>



    


 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://arcticwild.com/" className="btn btn-xl btn-light mr-4">
       Arctic Wild
        </a>
        
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href=" http://vienneparis.leoparpeix.fr/" className="btn btn-xl btn-light mr-4">
        Vienne - Paris
        </a>
        
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://gucciladybug.gucci.com/" className="btn btn-xl btn-light mr-4">
        Play Nature Game Here
        </a>
        
      </div>
    </section>





    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        
        <a href="http://naturehub.netlify.app" className="btn btn-xl btn-dark">
          Nature 
        </a>
      </div>
    </section>






 <section className="content-section" id="portfolio">
      <div className="container">
        <div className="content-section-heading text-center">
          <h3 className="text-secondary mb-0">Browse Smartly</h3>
          <img className="img-fluid" src={p14} alt="" />
          <h2 className="mb-5"> Explore Natural Beauty..<i className="fab fa-creative-commons-remix fa-spin"></i></h2>
        </div>
        
      </div>
    </section>










    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        
        <a href="https://www.sleepiest.com/" className="btn btn-xl btn-dark">
          Sleepiest
        </a>
      </div>
    </section>







    <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        
        <a href="https://rested.co/" className="btn btn-xl btn-dark">
          Rested
        </a>
      </div>
    </section>











 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://unsplash.com/wallpapers/screen/4k" className="btn btn-xl btn-light mr-4">
         Splash
        </a>
        <a href="https://www.worldatlas.com/" className="btn btn-xl btn-dark">
         World Atlas
        </a>
      </div>
    </section>







<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.bigskyhealth.com/" className="btn btn-xl btn-light mr-4">
         Big Sky health
        </a>
        <a href="https://www.templetonprize.org/" className="btn btn-xl btn-dark">
        Templetonprize
        </a>
      </div>
    </section>







 <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.yukon1000.org/" className="btn btn-xl btn-light mr-4">
          Yukon1000
        </a>
       
      </div>
    </section>



     <section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.nationalgeographic.com/" className="btn btn-xl btn-light mr-4">
          National Geographic
        </a>
       
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.nasa.gov/" className="btn btn-xl btn-light mr-4">
          Space Exploration
        </a>
       
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://visithumboldt.com/" className="btn btn-xl btn-light mr-4">
          Visit Thumboldt
        </a>
       
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://localadventure.mammut.com/en/adventure" className="btn btn-xl btn-light mr-4">
          Local Adventure
        </a>
       
      </div>
    </section>





<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://only.one/" className="btn btn-xl btn-light mr-4">
          Only.One
        </a>
       
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://nzonfoot.com/" className="btn btn-xl btn-light mr-4">
          New Zealand on Foot
        </a>
       
      </div>
    </section>




<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://www.meatable.com/" className="btn btn-xl btn-light mr-4">
          Meatable
        </a>
       
      </div>
    </section>


<section className="content-section bg-primary text-white">
      <div className="container text-center">
        <h2 className="mb-4"></h2>
        <a href="https://savetheseasons.on.george.no/" className="btn btn-xl btn-light mr-4">
          Save The Seasons
        </a>
       
      </div>
    </section>




    {/* <section id="contact" className="map">
      <iframe
        width="100%"
        height="100%"
        frameborder="0"
        scrolling="no"
        marginheight="0"
        marginwidth="0"
        src="https://maps.google.com/maps?f=q&amp;source=s_q&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A&amp;output=embed"
      ></iframe>
      <br />
      <small>
        <a href="https://maps.google.com/maps?f=q&amp;source=embed&amp;hl=en&amp;geocode=&amp;q=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;aq=0&amp;oq=twitter&amp;sll=28.659344,-81.187888&amp;sspn=0.128789,0.264187&amp;ie=UTF8&amp;hq=Twitter,+Inc.,+Market+Street,+San+Francisco,+CA&amp;t=m&amp;z=15&amp;iwloc=A"></a>
      </small>
    </section> */}

    <ScrollToTop />
    <Footer />
  </Layout>
);

export default IndexPage;
